import { Loader2, ShieldCheck, HeartHandshake } from "lucide-react";
import { Link } from "react-router-dom";
import { money } from "../lib/api";
import { IMPACT_LINE } from "../pages/Impact";

export const OrderSummary = ({ record, promo, setPromo, onApplyPromo, onPay, paying }) => (
  <aside className="hy-glass p-8 h-fit lg:sticky lg:top-28 space-y-6" data-testid="checkout-summary">
    <div className="hy-label">Order Summary</div>
    <div className="space-y-3 text-sm">
      <div className="flex justify-between">
        <span className="text-slate-400">{record.edition} price</span>
        <span className="text-white">{money(record.base_amount)}</span>
      </div>
      {record.discount > 0 && (
        <div className="flex justify-between text-emerald-300" data-testid="checkout-discount">
          <span>Promo {record.promotion_code}</span><span>−{money(record.discount)}</span>
        </div>
      )}
      <div className="hy-rule my-4" />
      <div className="flex justify-between font-display text-xl">
        <span className="text-slate-300">Total</span>
        <span className="text-amber-200" data-testid="checkout-total">{money(record.amount)}</span>
      </div>
      <p className="text-[0.7rem] text-slate-500 leading-relaxed pt-1">
        Includes the physical photo-framed certificate, digital certificate and QR verification.
      </p>
    </div>

    {!record.promotion_code && (
      <div>
        <div className="hy-label mb-3">Apply a promo code</div>
        <div className="flex gap-2">
          <input value={promo} onChange={(e) => setPromo(e.target.value)} className="hy-input"
            placeholder="GENESIS10" data-testid="checkout-promo-input" />
          <button onClick={onApplyPromo} className="hy-btn-ghost px-4 text-xs uppercase" data-testid="checkout-promo-btn">
            Apply
          </button>
        </div>
      </div>
    )}

    <button onClick={onPay} disabled={paying} data-testid="pay-now-btn"
      className="hy-btn w-full py-4 text-xs uppercase flex items-center justify-center gap-2 disabled:opacity-60">
      {paying && <Loader2 className="w-4 h-4 animate-spin" />} Pay {money(record.amount)}
    </button>

    <div className="flex gap-3 text-[0.7rem] text-slate-500 leading-relaxed">
      <ShieldCheck className="w-4 h-4 shrink-0 text-amber-500/70" />
      Payment is processed securely by Cashfree. Your registration is a private commemorative record and
      does not convey ownership of any celestial body.
    </div>

    <Link to="/impact" className="flex gap-3 text-[0.7rem] text-amber-200/80 leading-relaxed hover:text-amber-200"
      data-testid="checkout-impact-note">
      <HeartHandshake className="w-4 h-4 shrink-0" />
      {IMPACT_LINE}
    </Link>
  </aside>
);
